/**
 * Date formatting for a Polish UI.
 *
 * These were bare toLocaleString() / toLocaleDateString() calls, which follow
 * the *browser's* locale rather than the app's. On an English-locale browser
 * that rendered "8/18/2026, 8:59:00 AM" in an otherwise Polish interface --
 * and, worse, month/day ordering that a Polish reader misreads for the first
 * twelve days of any month.
 *
 * The surrounding code already formats prices with Intl.NumberFormat('pl-PL')
 * and collates search with toLocaleLowerCase('pl'), so the dates were the
 * outlier rather than the intent.
 */
const LOCALE = 'pl-PL';

/** e.g. "18.08.2026" */
export function formatDate(value: string | number | Date | null | undefined): string {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleDateString(LOCALE);
}

/** e.g. "18.08.2026, 08:59" -- seconds are noise in a listing. */
export function formatDateTime(value: string | number | Date | null | undefined): string {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString(LOCALE, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
